"use strict";

import angular from "angular";

import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";

class RelatedCompaniesDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService, $state, $scope) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.data = locals.data;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;
        this.$scope = $scope;

        this.searchText = "";
        this.filterText = "";
        this.filterShared = "";
        this.filterHasRelationBySource = "";
        console.log("RelatedCompaniesDialogCtrl");

        this.companies = [
            {
                name: "Apple Computer Brasil Ltda",
                state: `<i class="fas fa-check-circle"></i>`
            },
            {
                name: "Dashboard tecnologia s.a",
                state: `<i class="fas fa-times-circle"></i>`
            },
            {
                name: "H & E Instituto de Patologia Ltda",
                state: `<i class="fas fa-check-circle"></i>`
            },
            {
                name: "See Materiais Gráficos LTDA",
                state: `<i class="fas fa-check-circle"></i>`
            }
        ];

        this.orderField = "";
    }

    $onInit() {
        this._setColumnConnect();
    }

    onGoToIntegration() {
        const sourceScheduler = this.locals.reportSchedule.props.reportConfigs
            .source;

        this.$mdDialog.hide();
        const stateBySource = {
            simplesNacional: "nucont.accounting.integration.serpro",
            fin: "nucont.accounting.integration.omie"
        };

        if (!stateBySource[sourceScheduler]) return;

        const sourceSystem = { simplesNacional: "tax" };

        window.open(
            this.$state.href(stateBySource[sourceScheduler], {
                source: SourceConvert.toHuman(
                    sourceSystem[sourceScheduler] || sourceScheduler
                )
            }),
            "_blank"
        );
    }

    _setColumnConnect() {
        this.showColumnConnect = ["fin", "simplesNacional"].includes(
            this.locals.reportSchedule.props.reportConfigs.source
        );
    }

    onOrderBy(field) {
        if (this.orderField === field) return (this.orderField = "");

        this.orderField = field;
    }

    onFilterByShared(shared) {
        this.filterHasContact = "";
        if (this.filterShared === shared) return (this.filterShared = "");

        this.filterShared = shared;
    }

    onFilterByRelationBySource(shared) {
        if (this.filterHasRelationBySource === shared)
            this.filterHasRelationBySource = "";
        else this.filterHasRelationBySource = shared;
    }

    onFIlterHasContact(contact) {
        this.filterShared = "";
        if (this.filterHasContact === contact)
            return (this.filterHasContact = "");
        else this.filterHasContact = contact;
    }
}

angular
    .module("nucont.shared")
    .controller("RelatedCompaniesDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        "$state",
        "$scope",
        RelatedCompaniesDialogCtrl
    ]);
